@if (data.generatePin) {
  <div class="block three-column">
    <div class="form-element">
      <label class="required" for="confirm_pin">Pin</label>
      <div class="form-group input-group">
        <input type="{{eye != 'fa-eye'?'number':'password'}}" class="form-control" id="pin" placeholder="Enter" name="pin"
          [(ngModel)]="generatePinObj.pin">
        <div class="input-group-append">
          <div class="input-group-text kx-search-btn-icon">
            <span (click)="eye=(eye == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
              <i class="fa {{eye}}"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-element">
      <label class="required" for="confirm_pin">Confirm Pin</label>
      <div class="form-group input-group">
        <input type="{{eye2 != 'fa-eye'?'number':'password'}}" class="form-control" id="confirm_pin" placeholder="Enter"
          name="confirm_pin" [(ngModel)]="generatePinObj.confirm_pin">
        <div class="input-group-append">
          <div class="input-group-text kx-search-btn-icon">
            <span (click)="eye2=(eye2 == 'fa-eye' ? 'fa-eye-slash':'fa-eye')">
              <i class="fa {{eye2}}"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="mt-2 text-center">
  <p>{{'field.label.Enter_otp' | translate | async}}</p>
</div>
<div class="text-center">
  <app-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
  </app-otp-input>
</div>
<div class="col-12 p-0 mt-4 text-center">
  @if (!data.generatePin) {
    <button type="submit" class="aside-fixed-button primary-btn submitButton"
      (click)="this.authenticationService.getUserType() == 'patient' ? verifyOtp():verifyMemberOtp()"
      [disabled]="!showButton">
      {{'button.submit' | translate | async}} <i class="fa fa-check" aria-hidden="true"></i>
    </button>
  }
  @if (data.generatePin) {
    <button type="submit" class="aside-fixed-button primary-btn submitButton"
      (click)="verifyPin()" [disabled]="!showButton">
      {{'button.submit' | translate | async}} <i class="fa fa-check" aria-hidden="true"></i>
    </button>
  }
  @if (authenticationService.getUserType() == 'patient' && !data.generatePin) {
    <div class="col-12 mt-1 p-0">
      @if (!showTimer) {
        <span [ngClass] style="cursor: pointer;color: #20a8d8;" (click)="resendCode()">Resend
        OTP</span>
      }
      @if (showTimer) {
        <span style="cursor: not-allowed; color: gray;">Resend OTP</span>
      }
      @if (showTimer) {
        <span class="timer">
          {{timer}} sec
        </span>
      }
    </div>
  }
</div>